import { TOKEN_PROGRAM_ID } from "@solana/spl-token";
import { useConnection } from "@solana/wallet-adapter-react";
import { PublicKey } from "@solana/web3.js";
import { SPL_ASSOCIATED_TOKEN_ACCOUNT_PROGRAM_ID } from "containers/RaffleDetails";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const RaffleItem = ({ raffle }: { raffle: any }) => {
  const { connection } = useConnection();
  const [totalTickets, setTotalTickets] = useState(null);

  async function refreshAll() {
    getTotalTickets();
  }

  useEffect(() => {
    refreshAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const date1 = dayjs(raffle.endDate);
  const endDate = date1.diff(new Date(), "second");
  const ended = date1.diff(new Date(), "second") < 0;

  const getTotalTickets = async () => {
    const test = await PublicKey.findProgramAddress(
      [
        new PublicKey(raffle.receiverWallet).toBuffer(),
        TOKEN_PROGRAM_ID.toBuffer(),
        new PublicKey(raffle.tokenMint).toBuffer(),
      ],
      SPL_ASSOCIATED_TOKEN_ACCOUNT_PROGRAM_ID
    );

    if (test) {
      const sigs = await connection.getSignaturesForAddress(
        new PublicKey(test[0]?.toString()),
        {
          limit: 1000,
        }
      );
      const result = sigs.reduce(
        (total, currentValue) =>
          (total =
            total +
            Number(
              currentValue && raffle.raffleId.length > 1
                ? currentValue.memo.substring(13, 15) === raffle.raffleId
                  ? raffle.type === "whitelist"
                    ? currentValue.memo
                        .substring(
                          currentValue.memo.indexOf(""),
                          currentValue.memo.lastIndexOf(";")
                        )
                        .substring(18)
                    : currentValue.memo.substring(18)
                  : 0
                : currentValue.memo.substring(13, 14) === raffle.raffleId
                ? raffle.type === "whitelist"
                  ? currentValue.memo
                      .substring(
                        currentValue.memo.indexOf(""),
                        currentValue.memo.lastIndexOf(";")
                      )
                      .substring(17)
                  : currentValue.memo.substring(17)
                : 0
            )),
        0
      );
      setTotalTickets(result);
    }
  };

  return (
    <RaffleItemContainer>
      <RaffleItemImage src={raffle.raffleImage} />
      <RaffleItemDetails>
        <h3>{raffle.raffleName}</h3>
        <RaffleItemDetailsGrid>
          <p>{totalTickets ?? 0} sold</p>
          <p>{raffle.winners} winner</p>
        </RaffleItemDetailsGrid>
        {!ended ? (
          <p>
            Ends: {""}
            {endDate > 86400
              ? `${(endDate / 60 / 60 / 24).toFixed(0)} days`
              : endDate > 3600
              ? `${(endDate / 60 / 60).toFixed(0)} hrs`
              : endDate < 3600
              ? `${(endDate / 60).toFixed(0)} mins`
              : `${endDate} seconds`}
          </p>
        ) : (
          <p>Raffle closed!</p>
        )}
        {!ended ? (
          <Link to={`/raffle/${raffle.raffleObjectId}`}>Join Raffle</Link>
        ) : (
          <Link className="winners" to={`/raffle/${raffle.raffleObjectId}`}>
            View Winners
          </Link>
        )}
      </RaffleItemDetails>
    </RaffleItemContainer>
  );
};

export default RaffleItem;

const RaffleItemContainer = styled.div`
  background: #fff;
  border-radius: 16px;
  margin-bottom: 20px;
  margin-right: 20px;
  overflow: hidden;
  width: 320px;
`;

const RaffleItemImage = styled.img`
  height: 320px;
  width: 320px;
`;

const RaffleItemDetails = styled.div`
  height: 215px;
  padding: 16px;
  position: relative;
  text-align: center;

  h3 {
    color: #222;
    font-family: "Oswald";
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 12px;
  }

  p {
    color: #999;
    font-family: "Work Sans";
    font-size: 18px;
    font-weight: 400;
    line-height: 1.2;
    margin-bottom: 8px;
  }

  a {
    align-items: center;
    background: transparent;
    border: 2px solid rgb(70, 130, 180);
    border-radius: 8px;
    bottom: 16px;
    color: rgb(70, 130, 180);
    display: flex;
    font-family: "Oswald";
    font-size: 18px;
    font-weight: 600;
    justify-content: center;
    left: 16px;
    min-height: 40px;
    position: absolute;
    right: 16px;

    &:hover {
      background: rgb(70, 130, 180);
      color: #fff;
      text-decoration: none;
    }

    &.winners {
      background: #6c6b87;
      border: 2px solid #6c6b87;
      color: #fff;
    }
  }
`;

const RaffleItemDetailsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;
